import React, { useState } from 'react';
import classNames from 'classnames/bind';
import CheckboxField from '@/components/CustomTravel/ServiceFormFields/CheckboxField';
import useCustomRecommend from '@/hooks/custom/useCustomRecommend';

import styles from './SelectLocationForm.module.scss';
import { CustomRecommend } from '@/types/apollo';
const cx = classNames.bind(styles);

export const RecommendCities = ({ recommendSelectedCount }: { recommendSelectedCount: number }) => {
  const customRecommends = useCustomRecommend();
  const recommendMaxCount = 2;
  const [selectedCount, setSelectedCount] = useState(recommendSelectedCount);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      setSelectedCount(selectedCount + 1);
    } else {
      setSelectedCount(selectedCount - 1);
    }
  };
  const getSelectedCount = () => {
    return selectedCount;
  };

  if (!customRecommends?.length) return null;

  return (
    <div
      className={cx('RecommendCities')}
      data-event-nlog="imp"
      data-event-area-code="customtravel.recommendlocation"
      data-event-value={customRecommends.map(({ cityCodes }, i) => `${cityCodes.join('-')}-${i}`).join(',')}
    >
      <div className={cx('description')}>
        인기 여행 코스 중 가고 싶은 코스로 변경할 수 있어요.
        <br />
        <i>(최대 2개 선택 가능)</i>
      </div>
      <div className={cx('checkboxes')}>
        {customRecommends.map((data: CustomRecommend, i) => (
          <CheckboxField
            className={cx('checkbox')}
            name={`destinations.${data.cityCodes?.join('-')}`}
            label={data.name || ''}
            key={data.cityCodes?.join('-')}
            onChange={onChange}
            getSelectedCount={getSelectedCount}
            maxCount={recommendMaxCount}
            nlogAreaCode={`cus.selfdestination0${i}`}
          />
        ))}
      </div>
    </div>
  );
};
